module.exports = __webpack_public_path__ + "img/loading.2a22123f.gif";